import { ChevronRight, CircleUser, FullscreenIcon, LogOut } from "lucide-react";
import { Link } from "react-router-dom";
import { Robot } from "../../components/icons/robot";
import { useAuth } from "../../auth/useAuth";
import { useTranslation } from "react-i18next";
import { useMachine } from "../../queries/machine/use-machine";
import { Skeleton } from "../../components/ui/skeleton/skeleton";
import { useFullScreen } from "@/lib/use-full-screen";
import { ROUTES } from "@/routes";

export function UserSection() {
  const { logout, user } = useAuth();
  const { t } = useTranslation();
  const { machine, isLoading } = useMachine();
  const { isFullScreen, toggleFullScreen } = useFullScreen();

  return (
    <div className="bg-header-chip shadow rounded p-3 flex flex-col gap-3">
      <div>
        <p className="font-semibold flex gap-2 items-center mt-1">
          <CircleUser />
          {user?.name}
        </p>
      </div>
      <hr className="border-foreground opacity-30" />
      <Link
        to={ROUTES.SELECT_MACHINE}
        className="flex gap-2 text-sm items-center truncate"
      >
        <Robot className="h-4 w-4 flex-shrink-0" />
        {isLoading && (
          <Skeleton className="h-6 w-2/3  bg-primary-foreground/50" />
        )}
        {!isLoading && (
          <span className="truncate">
            {machine ? machine.EquipmentNId : t("nav.selectMachine")}
          </span>
        )}
        <ChevronRight strokeWidth={1} className="ml-auto flex-shrink-0" />
      </Link>
      <button
        className="flex gap-2 text-sm items-center"
        onClick={toggleFullScreen}
      >
        <FullscreenIcon className="h-4 w-4" />
        {isFullScreen ? t("nav.exitFullscreen") : t("nav.enterFullscreen")}
      </button>
      <button className="flex gap-2 text-sm items-center" onClick={logout}>
        <LogOut className="h-4 w-4" />
        {t("nav.logout")}
      </button>
    </div>
  );
}
